import React from "react";

type Props = {
	payload: {
		workflow: { name: string; forms: unknown[] };
		forms: { name: string; questions: unknown[] }[];
		questions: unknown[];
	};
};

export const ReviewWorkflowPreview = ({ payload }: Props): React.ReactElement => {
	const totalQuestions = payload.questions.length;
	return (
		<div className="space-y-5">
			<div className="grid grid-cols-2 gap-3">
				<Stat value={payload.forms.length} label={`Form${payload.forms.length === 1 ? "" : "s"}`} />
				<Stat value={totalQuestions} label="Questions total" />
			</div>

			<div>
				<div className="mb-2 text-caption font-semi-bold text-neutral-7">Form sequence</div>
				<ol className="space-y-2">
					{payload.forms.map((form, ii) => (
						<li
							key={ii}
							className="flex items-center gap-3 rounded-sm bg-neutral-1 px-3 py-3 ring-1 ring-neutral-2"
						>
							<span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-neutral-0 text-caption font-semi-bold text-neutral-7 tabular-nums ring-1 ring-neutral-2">
								{ii + 1}
							</span>
							<span className="flex-1 truncate text-paragraph-3 font-semi-bold text-neutral-9">
								{form.name}
							</span>
							<span className="text-caption text-neutral-7 tabular-nums">{form.questions.length} q</span>
						</li>
					))}
				</ol>
			</div>
		</div>
	);
};

const Stat = ({ value, label }: { value: number; label: string }): React.ReactElement => (
	<div className="rounded-sm bg-neutral-1 px-4 py-3 ring-1 ring-neutral-2">
		<div className="text-heading-4 font-semi-bold text-neutral-9 tabular-nums">{value}</div>
		<div className="mt-1.5 text-caption font-semi-bold text-neutral-7">{label}</div>
	</div>
);

export default ReviewWorkflowPreview;
